import axios from 'axios';
import { AffiliateData, Category, ContactDetails, SubCategory, Topic, CurrentUser, DeeplinkTopic } from 'types';

const API_URL = `${process.env.PUBLIC_URL}/api`;

const axiosInstance = axios.create({
  baseURL: API_URL,
});

// Request middleware
axiosInstance.interceptors.request.use(
  (config) => {
    // Add something to each request
    return config;
  },
  (error) => {
    // Do something for each request error.
    return Promise.reject(error);
  }
);

// Targeting criteria response middleware
axiosInstance.interceptors.response.use(
  (response) => {
    // Do something after each successful response
    return response;
  },
  (error) => {
    // Do something for each api error.
    // e.g. redirect 401 responses to login page
    return Promise.reject(error);
  }
);

const request = (config = {}) => axiosInstance(config);

export default {
  getHeaderData: async () => {
    return request({
      method: 'GET',
      url: '/header-data',
    }).then(({ data }) => data);
  },
  getAffiliateData: async () => {
    return request({
      method: 'GET',
      url: '/faq/affiliate-data',
    }).then(({ data }) => data as AffiliateData);
  },
  getContactDetails: () => {
    return request({
      method: 'GET',
      url: '/faq/contact-details',
    }).then(({ data }) => data as ContactDetails);
  },
  getFaqCategories: async () => {
    return request({
      method: 'get',
      url: '/faq',
    }).then(({ data }) => data as Category[]);
  },
  getFaqCategory: async (catId: number | string) => {
    return request({
      method: 'GET',
      url: '/faq/category/' + catId,
    }).then(({ data }) => data as SubCategory[]);
  },
  getTopic: async (topicId: number) => {
    return request({
      method: 'GET',
      url: '/faq/topic/' + topicId,
    }).then(({ data }) => data as Topic);
  },
  getTopicByAlias: async (alias: string) => {
    return request({
      method: 'GET',
      url: '/faq/deeplink/' + alias,
    }).then(({ data }) => data as DeeplinkTopic);
  },
  getTopicContent: async (topicId: number) => {
    return request({
      method: 'GET',
      url: '/api/faq/topic/content/' + topicId,
    }).then(({ data }) => data);
  },
  getMostPopular: async () => {
    return request({
      method: 'GET',
      url: '/faq/popular/',
    }).then(({ data }) => data);
  },
  getTopicsByKeyword: async (keyword: string) => {
    return request({
      method: 'POST',
      url: '/faq/search/',
      data: `"=${keyword}"`,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(({ data }) => data as Topic[]);
  },
  postQuestionSubmit: async (question: any) => {
    return request({
      method: 'POST',
      url: 'https://matchcom.zendesk.com/api/v2/requests.json',
      data: question,
    })
      .then()
      .catch(({ error }) => {
        console.log({ error });
      });
  },
  postQuestionSubmitLatamZendesk: async (question: any, brand: string) => {
    return request({
      method: 'POST',
      url: `https://${brand}.zendesk.com/api/v2/requests.json`,
      data: question,
    })
      .then()
      .catch(({ error }) => {
        console.log({ error });
      });
  },
  getCurrentUserId: async () => {
    return request({
      method: 'GET',
      url: 'faq/user'
    }).then(({ data }) => data as CurrentUser);
  },
};
